export default {
  default: {
    buttons: {
      manageRecipients: 'Manage Recipients',
    },
  },
}
